import { computed } from '@ember/object';

export default function notImplemented(errorMessage) {
  errorMessage = errorMessage || 'Computed property not implemented';
  return computed(function () {
    throw errorMessage;
  });
}
